import * as debounce from 'lodash.debounce';
import * as React from 'react';
import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { inject } from 'mobx-react';
import { UitkSlider } from 'uitk-react-slider';

import { FormFieldBinding } from './form-field-binding';
import { SearchFormFieldProps } from 'components/common/search-form';

export type LocalizedSliderProps = LocalizedComponentProps & SearchFormFieldProps & SliderProps;

export interface SliderProps {
  analytics?: AnalyticsStore;
}

@withLocalization
@FormFieldBinding
@inject('analytics')
export class Slider extends React.Component<LocalizedSliderProps> {
  private sendTrackingDebounced;

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.formatValueForDisplay = this.formatValueForDisplay.bind(this);
    this.formatSecondaryValueForDisplay = this.formatSecondaryValueForDisplay.bind(this);
    this.sendTrackingDebounced = debounce(this.sendTracking, 300);
  }

  public componentDidMount() {
    const { model } = this.props;
    const key = 'priceFilterBuckets';
    if (model && model[key] && model[key].length > 0) {
      const [lowerValue, upperValue] = model[key];
      this.handleChange(lowerValue, upperValue, false);
    }
  }

  private get options() {
    const { sortAndFilterOptions, modelKey } = this.props;
    const options = sortAndFilterOptions && sortAndFilterOptions[modelKey];

    return options || {};
  }

  private get sliderRange(): string[] {
    const { model, modelKey, fieldNameOverrides } = this.props;
    const { min: defaultMin, max: defaultMax } = this.options;
    const key = (fieldNameOverrides && fieldNameOverrides[modelKey]) || modelKey;
    const selectedRange = model && model[key] && model[key].length > 0 ? model[key] : [defaultMin, defaultMax];

    return selectedRange;
  }

  private handleChange(lowerValue: number, upperValue: number, track: boolean = true): void {
    const { updateModel } = this.props;
    const { name } = this.options;
    const sliderValue = [lowerValue, upperValue];

    if (track) {
      this.sendTrackingDebounced(sliderValue);
    }

    if (typeof updateModel === 'function') {
      updateModel({
        target: {
          name,
          value: sliderValue,
          delay: true
        }
      });
    }
  }

  private sendTracking(value: number[]) {
    const { analytics } = this.props;
    const { name } = this.options;
    const suffix = `${name}Slider.${value}`;
    analytics.clickTracker(`.${suffix}`, suffix, {}, () => null)();
  }

  private formatValueForDisplay(value: number): string {
    const subLabel = this.options.subLabel || '';

    return `${subLabel}${value}`;
  }

  private formatSecondaryValueForDisplay(value: number): string {
    const subLabel = this.options.subLabel || '';
    const displayValue = value === 0 ? `${subLabel}${this.options.max}+` : `${subLabel}${value}`;

    return value === this.options.max ? `${displayValue}+` : displayValue;
  }

  public render() {
    const { l10n } = this.props;
    const { formatText } = l10n;
    const { label, name, max, min, step } = this.options;
    const [lowerValue, upperValue] = this.sliderRange;

    return (
      <fieldset data-stid="price-slider-container">
        <legend className="filter-title uitk-type-heading-400 uitk-type-bold">{label}</legend>
        <UitkSlider
          type="dual"
          min={min}
          max={max}
          step={step}
          name={name}
          lowerValue={parseFloat(lowerValue)}
          upperValue={parseFloat(upperValue)}
          id={`${this.props.modelKey}-slider`}
          handleChange={this.handleChange}
          formatValueForDisplay={this.formatValueForDisplay}
          primaryLiveAnnounceMsg={formatText('hotels.searchResults.filtersDialog.price.minimumLiveAnnounce')}
          secondaryLiveAnnounceMsg={formatText('hotels.searchResults.filtersDialog.price.maximumLiveAnnounce')}
          formatSecondaryValueForDisplay={this.formatSecondaryValueForDisplay}
        />
      </fieldset>
    );
  }
}
